import React, { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import api from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";
import { AdminHeader } from "@/components/admin/AdminShared";

export default function AdminReferrals() {
  useSEO("Admin · Referrals");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/referrals").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <AdminHeader title="Referrals" subtitle="Referral leaderboard & tracking" />
      <div className="card-surface rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-slate-500 border-b border-white/10"><th className="p-4">#</th><th className="p-4">Member</th><th className="p-4">Email</th><th className="p-4">Code</th><th className="p-4">Referrals</th></tr></thead>
          <tbody>
            {rows.length === 0 ? <tr><td colSpan={5} className="p-8 text-center text-slate-500">No referrals recorded yet.</td></tr>
              : rows.map((r, i) => (
                <tr key={r.id || i} className="border-b border-white/5" data-testid={`ref-row-${i}`}>
                  <td className="p-4 text-brand-cyan font-mono">{i + 1}</td>
                  <td className="p-4 text-white">{r.name}</td>
                  <td className="p-4 text-slate-400">{r.email}</td>
                  <td className="p-4 font-mono text-slate-400">{r.referral_code}</td>
                  <td className="p-4"><span className="inline-flex items-center gap-1.5 text-brand-green font-semibold"><Gift className="h-4 w-4" /> {r.referral_count}</span></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
